<template>
    <div>
        <LiveSession v-if="joinedSession" />
        <GuestWelcome
            v-else
            :displayName="displayName"
            @joinSession="joinSession()"
        />
    </div>
</template>

<script>
import GuestWelcome from "./GuestWelcome";
import LiveSession from "../LiveSession";

export default {
    name: "GuestPage",
    data() {
        return {};
    },
    computed: {
        displayName() {
            return (
                this.$store.getters.user && this.$store.getters.user.displayName
            );
        },

        joinedSession() {
            return this.$store.state.joinedSession;
        },
    },
    methods: {
        joinSession() {
            this.$store.dispatch("joinSession");
        },
    },

    components: {
        GuestWelcome,
        LiveSession,
    },
};
</script>